<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{titolo}}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.close()"></button>
</div>
<div class="modal-body">
    <form [formGroup]="formUtente">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="nome">Nome</label>
                    <input type="text" class="form-control" formControlName="nome" id="nome" placeholder="Nome">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="cognome">Cognome</label>
                    <input type="text" class="form-control" formControlName="cognome" id="cognome" placeholder="Cognome">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="email">Email</label>
                    <input type="text" class="form-control" formControlName="email" id="email" placeholder="Email">
                </div>
            </div>
        </div>
        <div class="row ">
            <div class="col-md-12">
                <div class="form-group">
                    <label>Ruolo</label>
                    <mdb-form-control>
                    <mdb-select formControlName="ruolo">
                      <mdb-option *ngFor="let option of ruoli" [value]="option.id">{{
                        option.ruolo
                      }}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label">Seleziona Ruolo</label>
                  </mdb-form-control>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <label for="abilitato">Abilitato</label>
                <select class="form-control" formControlName="abilitato" id="abilitato">
                    <option value="1">Si</option>
                    <option value="0" selected="true">No</option>
                </select>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.close()">
        Chiudi
    </button>
    <button type="button" class="btn btn-primary" (click)="close()">Salva</button>
</div>